import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

// This component ensures that everytime a change of route is triggered
// the screen is scrolled to the top. This is not de default behaviour due to
// this app being an SPA.

const IPropTypes = {
  children: PropTypes.element.isRequired,
  location: PropTypes.object.isRequired,
};

class UnwrappedScrollToTop extends React.Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

UnwrappedScrollToTop.propTypes = IPropTypes;

const ScrollToTop = withRouter(UnwrappedScrollToTop);

export { ScrollToTop };



// WEBPACK FOOTER //
// ./src/routes/ScrollToTop.jsx